import { render, staticRenderFns } from "./AuthPopUp.vue?vue&type=template&id=7caac1da&"
import script from "./AuthPopUp.vue?vue&type=script&lang=js&"
export * from "./AuthPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports